<template>
  <dialog
    :class="['modal', { 'modal-open': true }]"
    @cancel.prevent="$emit('close')"
  >
    <div class="modal-box w-[calc(100%-32px)] max-w-md mx-4 sm:mx-auto p-5 sm:p-[28px] rounded-[24px] bg-white border border-[#22ec9b] relative shadow-2xl">
      <form method="dialog">
        <button
          class="btn btn-sm btn-circle btn-ghost absolute right-4 top-4 text-[#5b5c60]"
          @click.prevent="$emit('close')"
        >
          ✕
        </button>
      </form>
      <h3 class="font-bold text-lg text-[#043f42] font-['Raleway',sans-serif]">
        Archive Cohort
      </h3>
      <p class="py-4 text-[#5b5c60] font-['Raleway',sans-serif] text-sm leading-relaxed">
        Archive <strong>{{ cohort.name }}</strong>? It will be kept for audit records.
      </p>

      <div
        v-if="error"
        class="text-red-600 text-sm mb-4 font-['Raleway',sans-serif] p-2.5 bg-red-50 rounded-[10px] border border-red-200"
      >
        {{ error }}
      </div>

      <div class="modal-action mt-5 flex items-center justify-end gap-3">
        <button
          class="px-5 py-2.5 rounded-full border border-gray-300 text-gray-700 font-['Raleway',sans-serif] font-bold text-sm hover:bg-gray-50 transition-colors cursor-pointer bg-white"
          :disabled="isSubmitting"
          @click.prevent="$emit('close')"
        >
          Cancel
        </button>
        <button
          class="flex items-center justify-center px-5 py-2.5 rounded-full bg-[#01d680] text-[#043f42] hover:bg-[#00c270] font-['Raleway',sans-serif] font-bold text-sm transition-colors border-none cursor-pointer shadow-sm disabled:opacity-50"
          :disabled="isSubmitting"
          @click.prevent="submitArchive"
        >
          <span
            v-if="isSubmitting"
            class="w-4 h-4 mr-2 border-2 border-[#043f42] border-t-transparent rounded-full animate-spin"
          />
          Confirm Archive
        </button>
      </div>
    </div>
    <form
      method="dialog"
      class="modal-backdrop bg-[#00000099]"
    >
      <button @click.prevent="$emit('close')">
        close
      </button>
    </form>
  </dialog>
</template>

<script>
export default {
  name: 'ArchiveCohortModal',
  props: {
    cohort: { type: Object, required: true }
  },
  emits: ['close', 'archived'],
  data () {
    return {
      isSubmitting: false,
      error: null
    }
  },
  methods: {
    async submitArchive () {
      this.isSubmitting = true
      this.error = null

      try {
        const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
        const response = await fetch(`/cohorts/${this.cohort.id}/archive`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': csrfToken
          }
        })

        const data = await response.json()

        if (response.ok && data.success) {
          window.location.href = '/cohorts?status=archived'
        } else {
          this.error = data.error || 'Failed to archive cohort.'
        }
      } catch (err) {
        this.error = 'A network error occurred. Please try again.'
      } finally {
        this.isSubmitting = false
      }
    }
  }
}
</script>
